<ng-container [ngSwitch]="state">
    <div *ngSwitchCase="packingState.Picked" class="picked" [attr.data-test-id]="testId">&#x2022; Picked</div>
    <div *ngSwitchCase="packingState.Packing" class="packing" [attr.data-test-id]="testId">&#x2022; Packing</div>
    <div *ngSwitchCase="packingState.Packed" class="packed" [attr.data-test-id]="testId">&#x2022; Packed</div>
    <div *ngSwitchCase="packingState.Incident" class="incident" [attr.data-test-id]="testId">&#x2022; <ng-container *ngIf="status === undefined; else elseBlockIncident">Incident</ng-container></div>
</ng-container>
<ng-template #elseBlockIncident>{{status}}</ng-template>
